import './home_banner_style.scss';
import ImgFormAvatar from './../../assets/img_form_avatar.png';
import { useEffect, useState } from 'react';
import axios from 'axios';

export const HomeBanner = ({
    fields
}) => {
    const [isSucceed, setIsSucceed] = useState(false);
    const [fullName, setFullName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isFetching, setIsFetching] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        document.getElementById('phone').addEventListener('input', function (e) {
            var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            setPhone(!x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : ''));
        });
    }, []);

    const onSubmitForm = async (e) => {

        e.preventDefault();
        setIsSubmitting(true);

        try {
            await axios.post(
                '/wp-json/gf/v2/forms/1/submissions', // Replace {form_id} with your actual Gravity Form ID
                {
                    'input_1': fullName,
                    'input_3': email,
                    'input_4': phone,
                    'input_5': message,
                    'input_6': window.location.href,
                },
                {
                  headers: {
                    'Content-Type': 'application/json',
                  },
                }
            );
            // if (window.location.href?.includes("/es/")) {
            //     NotificationManager.success('¡El formulario se ha enviado correctamente!', '¡Éxito!');
            // } else {
            //     NotificationManager.success('Form has been submitted successfully!', 'Success!');
            // }
            setFullName('');
            setPhone('');
            setEmail('');
            setMessage('');
            setIsSucceed(true);
        } catch (err) {
            console.log(err);
        } finally {
            setIsSubmitting(false);
        }
        return false;
    }

    return <section id="home-banner" className="home-section">
        <div className="container">
            <div className='banner-area'>
                <div className='banner-left-section'>
                    <h1>{fields?.banner_pre_title ?? 'New York City Personal Injury Lawyers'}</h1>
                    <span className="banner-big-letters">{fields?.banner_title ?? "Compassionate Advocates, Fierce Fighters - Your Injury, Our Priority"}</span>
                    <p>{fields?.banner_description ?? 'We have recovered in excess of $350 million dollars in settlements and verdicts for clients over the past 40 years. Our attorneys have over 75 years of combined legal experience'}</p>
                </div>
                <div className='banner-right-section'>
                    <div className='banner-form-wrapper'>
                        <div className='form-heading'>
                            <span className='form-title'>100% Free Consultation</span>
                            <span className='form-sub-title'>Available 24/7</span>
                            <img src={ImgFormAvatar} />
                            <span className='form-description'>
                                Hi, this is Joe, founder of JTM Jr. & Associates.
                                We would love to connect and provide a free consultation
                            </span>
                            {
                                isSucceed && <span className='succeed'>Form submitted successfully!</span>
                            }
                        </div>
                        <form id="banner-form" onSubmit={onSubmitForm}>
                            <div className='form-fields'>
                                <input 
                                    type="text" 
                                    name='name' 
                                    id="name" 
                                    placeholder='Name' 
                                    required
                                    value={fullName}
                                    onChange={(e) => {
                                        setFullName(e?.target?.value ?? "")
                                    }}
                                />
                                <input 
                                    type="text" 
                                    name='phone' 
                                    id="phone" 
                                    placeholder='Phone' 
                                    required
                                    value={phone}
                                    onChange={(e) => {
                                        setPhone(e?.target?.value ?? "")
                                    }}
                                />
                                <input 
                                    type="email" 
                                    name='email' 
                                    id="email" 
                                    placeholder='Email' 
                                    required 
                                    value={email}
                                    onChange={(e) => {
                                        setEmail(e?.target?.value ?? "")
                                    }}
                                />
                                <textarea 
                                    name="message" 
                                    id="message" 
                                    placeholder='Tell us about your case'
                                    value={message}
                                    onChange={(e)=>{
                                        setMessage(e?.target?.value ?? "")
                                    }}
                                />
                            </div>
                            <button type="submit" className={`button ${isSubmitting ? 'disabled' : ''}`}>
                                { isSubmitting ? 'Submitting...' : 'Make an appointment'}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div className='features-wrapper'>
            <div className='features-repeater'>
                {
                    fields?.banner_features_repeater?.map((it, index) => <div className='block-feature-item' key={index}>
                        <h3 dangerouslySetInnerHTML={{ __html: it?.block_value }}></h3>
                        <span className='details'>{it?.block_details}</span>
                    </div>)
                }
            </div>
        </div>
    </section>
}